import { Component, OnInit, OnDestroy } from '@angular/core';

import { InternalMsgService } from '../services/internal.msg.service';
import { AccountService } from '../services/account.service';
import { Subscription } from 'rxjs';
import { AccountItem } from '../models/accountitem';

@Component({
    selector: 'reports',
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.css']
})
export class ReportsComponent implements OnInit, OnDestroy{
    loggedAccount: AccountItem = new AccountItem();
    visibleReport = 'detailed-reporting';
    msgSubscr: Subscription = new Subscription();

    constructor(
        private msgService: InternalMsgService,
        private accountService: AccountService) { 
    }

    ngOnInit() {
        this.msgService.onSelectedMenuSet( 3 );
        this.msgSubscr = this.msgService.loggedInAccountSet$.subscribe( 
            account => {
                this.loggedAccount = account;
            } );     
        this.accountService.fetchAccount();
    }

    ngOnDestroy() {
        this.msgSubscr.unsubscribe();
    }

    showThis(value: string) {
        if (value === undefined) return;
        this.visibleReport = value;
    }

    //Styr om tabbar visas i reporting
    showTab() {
        return this.loggedAccount.reporting;
    }

}
